import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import CollectionFab from './components/CollectionFab';
import CollectionActions from './components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import SearchHeader, { filterByKeyword } from './components/SearchHeader';
import { calendarsActions } from '../store';

const useStyles = makeStyles((theme) => ({
    columnAction: {
        width: '1%',
        paddingRight: theme.spacing(1),
    },
}));

const CalendarsPage = () => {
    const classes = useStyles();
    const t = useTranslation();
    const dispatch = useDispatch();
    const items = useSelector((state) => state.calendars.items);
    const loaded = useSelector((state) => state.calendars.loaded);
    const [searchKeyword, setSearchKeyword] = useState('');

    useEffectAsync(async () => {
        if (!loaded) {
            try {
                const response = await fetch('/api/tracking/calendars');
                if (response.ok) {
                    const result = await response.json();
                    dispatch(calendarsActions.update(result));
                } else {
                    throw Error(await response.text());
                }
            } catch {
                throw Error('Error');
            }
        }
    }, []);

    return (
        <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedCalendars']}>
            <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('sharedName')}</TableCell>
                        <TableCell className={classes.columnAction} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loaded ? Object.values(items).filter(filterByKeyword(searchKeyword)).map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>{item.name}</TableCell>
                            <TableCell className={classes.columnAction} padding="none">
                                <CollectionActions
                                    itemId={item.id}
                                    editPath="/settings/calendar"
                                    endpoint="calendars"
                                    removeAction={calendarsActions.remove}
                                />
                            </TableCell>
                        </TableRow>
                    )) : (<TableShimmer columns={2} endAction />)}
                </TableBody>
            </Table>
            <CollectionFab editPath="/settings/calendar" />
        </PageLayout>
    );
};

export default CalendarsPage;
